var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleClosed()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          Detalle de la Atención N° " +
                        _vm._s(_vm.localData.atenumero) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "", md12: "" } },
                                          [
                                            _c(
                                              "v-tabs",
                                              {
                                                staticClass:
                                                  "attentions_modal_tabs"
                                              },
                                              [
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "attentions"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Detalle de Atención\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "products"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Datos de Productos\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "series"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Datos de Series\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              sm12: "",
                                              md12: "",
                                              "mt-5": ""
                                            }
                                          },
                                          [
                                            _vm.step === "attentions"
                                              ? _c("AtencionesTab", {
                                                  attrs: { data: _vm.localData }
                                                })
                                              : _vm.step === "products" &&
                                                _vm.dataApi.products.length > 0
                                              ? _c("ProductsTab", {
                                                  attrs: {
                                                    data: _vm.dataApi.products,
                                                    data_full: _vm.localData
                                                  },
                                                  on: {
                                                    closeEvent: function(
                                                      $event
                                                    ) {
                                                      return _vm.handleClosed()
                                                    }
                                                  }
                                                })
                                              : _vm.step === "series" &&
                                                _vm.dataApi.series.length > 0
                                              ? _c("SeriesTab", {
                                                  attrs: {
                                                    data: _vm.dataApi.series
                                                  }
                                                })
                                              : _c("GridComponent", {
                                                  staticClass:
                                                    "ag-theme-material",
                                                  staticStyle: {
                                                    height: "220px"
                                                  },
                                                  attrs: {
                                                    "grid-options":
                                                      _vm.gridOptions
                                                  }
                                                })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }